function csellCustomInit() {
  function csellUpdateSvgIcon(container) {
    let crossSells = container.id == 'cross-sells' ? container : container.querySelector('#cross-sells');

    if(!crossSells) return;
    if (container.querySelectorAll('#cross-sells [data-xsorder]').length <= 4) {
      crossSells.classList.add('compressed')
    }

    let buttons = container.querySelectorAll('svg.flickity-button-icon');
    if(buttons.length == 0) return;

    function handleLastTransition() {
      if(crossSells.classList.contains('compressed')) return;

      let cards = document.querySelectorAll('#cross-sells [data-xsorder]')
      let viewport = document.querySelector('#cross-sells .flickity-viewport')

      if(cards[cards.length -1].classList.contains('is-selected') || cards[cards.length -2].classList.contains('is-selected') || cards[cards.length -1].classList.contains('is-selected') || cards[cards.length -3].classList.contains('is-selected')) {
        viewport.classList.add('transition-last');
      } else {
        viewport.classList.remove('transition-last');
      };
    };

    document.addEventListener('keydown', (event) => {
      if (
        (event.key === 'ArrowLeft' || event.key === 'ArrowRight') &&
        event.target.closest('#cross-sells')
      ) {
        handleLastTransition();
      };
    });

    let firstTransitionClick = false;
    buttons[1].addEventListener('click', () => {
      if (firstTransitionClick) return;

      if (
        document.querySelector('#cross-sells [data-xsorder="1"].is-selected') ||
        document.querySelector('#cross-sells [data-xsorder="2"].is-selected')
      ) {
        firstTransitionClick = true;
        for (let index = 0; index < 3; index++) {
          buttons[1].parentElement.click();
        }
        firstTransitionClick = false;
      }

      if(crossSells.classList.contains('compressed')) return;

      handleLastTransition();
    });

    buttons[0].addEventListener('click', () => {
      if(crossSells.classList.contains('compressed')) return;

      let cards = document.querySelectorAll('#cross-sells [data-xsorder]');
      let viewport = document.querySelector('#cross-sells .flickity-viewport');

      if(!(cards[cards.length -1].classList.contains('is-selected'))) {
        viewport.classList.remove('transition-last');
      }
    });


    buttons.forEach((btn) => {
      btn.setAttribute('viewBox', '0 0 20.33 26');
    })

    document.querySelectorAll('.flickity-button-icon .arrow').forEach((arrow) => {
      arrow.setAttribute(
        'd',
        'M 12.782,24.634 L 32.111,12.5 L 12.782,0 L 13,0.366 C 20,8.708 20,16.981 12.782,24.634 Z'
      );

      arrow.setAttribute('fill', '#fff');
      arrow.setAttribute('stroke', '#000');
      arrow.setAttribute('stroke-width', '1');
      arrow.setAttribute('stroke-linecap', 'round');
      arrow.setAttribute('stroke-linejoin', 'round');

      arrow.removeAttribute('transform');
    });
  }

  const content = document.querySelector('#main-content');

  if (!content) return;

  const updateCrossSells = () => {
    const crossSells = content.querySelector('#cross-sells');

    if (!crossSells) return false;

    document.querySelectorAll('#cross-sells .money [data-xs-link]:not(.formatted)').forEach((link) => {
      const [first, second] = link.textContent.split(',');

      if (second !== undefined) {
        link.innerHTML = `${first}<sup>${second}</sup>`;
      };
      link.classList.add('formatted');
    });

    const svgs = crossSells.querySelectorAll('svg.flickity-button-icon');

    if (svgs.length) {
      csellUpdateSvgIcon(crossSells);
      return true;
    }

    return false;
  };

  if (updateCrossSells()) {
    return;
  }

  const observer = new MutationObserver(() => {
    if (updateCrossSells()) {
      observer.disconnect();
    }
  });

  observer.observe(content, {
    childList: true,
    subtree: true
  });

  // setTimeout(() => {
  //   let viewport = document.querySelector('#cross-sells .flickity-viewport');
  //   let slider = document.querySelector('#cross-sells .flickity-viewport .flickity-slider');

  //   const sliderObserver = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       if (viewport.classList.contains('is-pointer-down')) {
  //         console.log('is-pointer-down up', slider);
  //       } else {
  //         console.log('is-pointer-down down', slider);
  //       }
  //     });
  //   });

  //   sliderObserver.observe(slider, {
  //     attributes: true,
  //     attributeFilter: ['style']
  //   });
  // }, 500);
};

setTimeout(() => {
  csellCustomInit();
}, 2000);

window.addEventListener('resize', () => {
  csellCustomInit();
});